import * as utils from '@wix/santa-editor-utils';

export function isDebugMode(): boolean {
  return (
    utils.url.getParameterByName('debug')?.includes('all') ||
    !!localStorage?.getItem('editor-debug')
  );
}
